import React from "react";
import 'normalize.css';


export default function DebtRecovery() {
  return (
    <main id="content" className="content">
        <section className="vc_row fullheight d-flex flex-wrap align-items-center bg-cover pt-150 pb-15" style={{ backgroundImage: "url(assets/demo/bg/bg-14.jpg)" }}>
  <div className="container">
    <div className="row">
      {/* Left Side: Content */}
      <div className="lqd-column col-md-6">
        <h3 className="text-white pr-md-5 mt-0 mb-40" data-split-text="true" data-split-options={{ type: "lines" }}>
           
          <span style={{ color: 'white' }}>Collect Kart - </span>
                <span style={{ color: 'red' }}>An Innovative Phygital Debt Recovery Solution by DocBoyz </span>
        </h3>
        {/* Collect Kart: An Innovative Phygital Debt Recovery Solution by DocBoyz */}
        <p className="text-white font-size-16 lh-185 pr-md-7 mb-60">
        For years, banks and financial services have sought a smarter way to enhance their debt collection efforts, reduce costs, and streamline the entire process. Recognizing this need, DocBoyz launched an initiative to create a cutting-edge payment collection platform through extensive research and development.
        <br></br>
        The sector has long struggled with challenges like unstructured data, poor communication management, lack of centralized monitoring, and limited access to analytics, leading to inefficient decision-making. To address these issues and simplify payment collection, we proudly present DB Collect Kart—designed to enhance efficiency and effectiveness in the debt recovery process.
        </p>
      </div>

      {/* Right Side: Image */}
      <div className="lqd-column col-md-6 d-flex justify-content-center">
        <img src="assets/img/DebtRec/team.jpeg" alt="Collect Kart Platform" className="img-fluid" style={{ borderRadius: '8px', maxHeight: '400px' }} />
      </div>
    </div>
  </div>
</section>

      {/* <section className="vc_row fullheight d-flex flex-wrap align-items-center bg-cover pt-150 pb-150" style={{ backgroundImage: "url(assets/demo/bg/bg-14.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="lqd-column col-md-6">
              <h1 className="text-white pr-md-5 mt-0 mb-40" data-split-text="true" data-split-options={{ type: "lines" }}>
                Collect Kart - An Innovative Phygital Debt Recovery Platform by DocBoyz
              </h1>
              <p className="text-white font-size-16 lh-185 pr-md-7 mb-60">
                From a long time, Banks & Financial Services companies needed a solution, which will reduce cost and debt collection time and enhance productivity. Designed for banks, NBFCs, and other lenders, Collect Kart combines advanced technology with a human network to ensure seamless loan recovery.
              </p>
            </div>
          </div>
        </div>
      </section> */}

      {/* Features Section */}
      <section className="vc_row bg-no-repeat pt-10 pb-10" style={{ backgroundImage: "url(assets/demo/bg/bg-76.svg)", backgroundPosition: "-90% 80%" }}>
  <div className="container">
    <div className="row">
      {/* Left Side: Image */}
      <div className="lqd-column col-md-6 d-flex justify-content-center pt-50">
        <img src="assets/img/DebtRec/Collect_01.jpeg" alt="Collect Kart Software Features" className="img-fluid" style={{ borderRadius: '8px', maxHeight: '400px' }} />
      </div>
      
      {/* Right Side: Content */}
      <div className="lqd-column col-md-6  justify-content-center">
        <h2>Collect Kart Debt Collection Software Features</h2>
        <ul>
          <li>Customization based on the client’s process</li>
          <li>Geolocation-based Agent & Task Monitoring</li>
          <li>Predictive Calling</li>
          <li>Historical Data Analysis</li>
          <li>Dashboards & MIS Reports</li>
          <li>API integration with Financial Systems such as LMS/CRM</li>
          <li>Automated ECG Analysis</li>
          <li>Automated alerts & notifications to the agency representatives</li>
          <li>Automated Triggering</li>
        </ul>
      </div>
    </div>
  </div>
</section>


      {/* Debt Collection Platform Section */}
      <section className="vc_row bg-cover pt-10 pb-10" style={{ backgroundImage: "url(assets/demo/bg/bg-76.svg)" }}>
  <div className="container">
    <h2>Collect Kart Debt Collection Platform</h2>
    <p>
      A well-trained team is involved to seamlessly manage other payment collection processes. It provides all the assistance and gets 360-degree support for recovery.
    </p>
    <div className="row">
      <div className="col-md-4 text-center">
        <img src="assets/img/DebtRec/upload.png" alt="Case Upload" className="mb-3" style={{ width: '80px', height: '80px' }} />
        <h3>1. Case Upload</h3>
        <p>The client uploads the collection cases using a CSV file into the system.</p>
      </div>
      <div className="col-md-4 text-center">
        <img src="assets/img/DebtRec/call.png" alt="Predictive Calling" className="mb-3" style={{ width: '80px', height: '80px' }} />
        <h3>2. Predictive Calling</h3>
        <p>Automated calls are initiated to the customers and records of the calls are saved.</p>
      </div>
      <div className="col-md-4 text-center">
        <img src="assets/img/DebtRec/active.png" alt="Assign FC" className="mb-3" style={{ width: '80px', height: '80px' }} />
        <h3>3. Assign FC</h3>
        <p>Call a Financial Consultant (FC) for physical visits where the customer is not reachable or requires assistance.</p>
      </div>
    </div>
    <div className="row">
      <div className="col-md-4 text-center">
        <img src="assets/img/DebtRec/Search.png" alt="Skip Tracing" className="mb-3" style={{ width: '80px', height: '80px' }} />
        <h3>4. Skip Tracing</h3>
        <p>Our team helps in tracing customers who are unresponsive or unreachable.</p>
      </div>
      <div className="col-md-4 text-center">
        <img src="assets/img/DebtRec/user.png" alt="Visit Customer" className="mb-3" style={{ width: '80px', height: '80px' }} />
        <h3>5. Visit Customer</h3>
        <p>Agents physically visit the customer’s location for payment collection or document retrieval.</p>
      </div>
      <div className="col-md-4 text-center">
        <img src="assets/img/DebtRec/pay.png" alt="Customer Pays" className="mb-3" style={{ width: '80px', height: '80px' }} />
        <h3>6. Customer Pays</h3>
        <p>Our system tracks payments made by the customer and generates automated receipts.</p>
      </div>
    </div>
  </div>
</section>
<section className="vc_row bg-no-repeat pt-10 pb-10" style={{ backgroundImage: "url(assets/demo/bg/bg-76.svg)", backgroundPosition: "-90% 80%" }}>
  <div className="container">
    <div className="row">
      
      {/* Left Side: Content (60%) */}
      <div className="lqd-column col-md-7 d-flex flex-column justify-content-center">
        <h2>Collectkart: Multi-Tenant Architecture for BFSI</h2>
        <p>
        DocBoyz has developed a multi-tenant version of its platform, designed specifically for BFSI companies. This innovative solution acts as an aggregator for agencies working with these financial institutions. By onboarding onto the DocBoyz multi-tenant platform, BFSI companies can seamlessly invite all their partner agencies to collaborate in one unified system.
        <br></br>
        This ensures that every agency utilizes the same DocBoyz framework to manage their cases, providing consistent data and results through a single channel. Agencies can leverage all the platform's features to enhance their efficiency and effectiveness in their operations.        </p>

      </div>

      {/* Right Side: Image (40%) */}
      <div className="lqd-column col-md-5 d-flex justify-content-center">
        <img src="assets/img/CollectKart/multitenant.png" alt="Collect Kart Software Features" className="img-fluid" style={{ borderRadius: '8px', maxHeight: '400px' }} />
      </div>
    </div>
  </div>
</section>


<section className="vc_row bg-no-repeat pt-10 pb-10" style={{ backgroundImage: "url(assets/demo/bg/bg-76.svg)", backgroundPosition: "-90% 80%" }}>
  <div className="container">
    <h2 className="text-center mb-5">Features of Collect Kart Debt Collection Software</h2>
    <div className="row">
      {/* <!-- First Row --> */}
      <div className="col-md-6 mb-4">
        <div className="d-flex align-items-center">
          <div className="me-4">
            <img src="assets/img/DebtRec/flexibility.png" alt="Flexibility" style={{ width: '100px', height: '100px' }} />
          </div>
          <div style={{ paddingLeft: '15px' }}>
            <h4>Flexibility</h4>
            <p>To relay the cases directly to an agency.</p>
          </div>
        </div>
      </div>
      <div className="col-md-6 mb-4">
        <div className="d-flex align-items-center">
          <div className="me-4">
            <img src="assets/img/DebtRec/control-icon.png" alt="Control" style={{ width: '100px', height: '100px' }} />
          </div>
          <div style={{ paddingLeft: '15px' }}>
            <h4>Control</h4>
            <p>Over number and type of cases done by the agencies.</p>
          </div>
        </div>
      </div>
    </div>
    <div className="row">
      {/* <!-- Second Row --> */}
      <div className="col-md-6 mb-4">
        <div className="d-flex align-items-center">
          <div className="me-4">
            <img src="assets/img/DebtRec/secured-icon.png" alt="Secured" style={{ width: '100px', height: '100px' }} />
          </div>
          <div style={{ paddingLeft: '15px' }}>
            <h4>Secured</h4>
            <p>The entire process happens on the secure DocBoyz platform.</p>
          </div>
        </div>
      </div>
      <div className="col-md-6 mb-4">
        <div className="d-flex align-items-center">
          <div className="me-4">
            <img src="assets/img/DebtRec/realtime-results-icon.png" alt="Realtime Results" style={{ width: '100px', height: '100px' }} />
          </div>
          <div style={{ paddingLeft: '15px' }}> 
            <h4>Realtime Results</h4>
            <p>Get the result in real-time as the case gets executed on the field.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
{/*  */}

<section className="vc_row bg-no-repeat pt-10 pb-10" style={{ backgroundImage: "url(assets/demo/bg/bg-76.svg)", backgroundPosition: "-90% 80%" }}>
        <div className="container">
          <div className="row">
            <div className="lqd-column col-md-6">
            <div className="benefits-container">
  <h2>Benefits of Debt Collection Software by Collect Kart</h2>
  <ul className="benefits-list">
    <li>✓ Improvement in the collection by 10x.</li>
    <li>✓ Swift action in each case.</li>
    <li>✓ AI technology-based effectual calling & supports performance tracking of agencies.</li>
    <li>✓ Hassle-free Reconciliation.</li>
    <li>✓ Real-Time Monitoring.</li>
    <li>✓ Ease in analyzing data and helping in offering a customized resolution.</li>
    <li>✓ Better reach to borrowers.</li>
  </ul>
</div>

            </div>
            {/* my-app\public\assets\img\Carees\Team01.jpeg */}
            <div className="lqd-column col-md-6">
              <img
                src="assets/img/DebtRec/Benefits.jpeg"
                alt="Job Opportunities at DocBoyz"
                style={{ width: '100%', borderRadius: '8px' }}
              />
            </div>
          </div>
        </div>
      </section>

      <section className="vc_row bg-light py-5" style={{ backgroundColor: "#d3d3d3" }}>
  <div className="container text-center">
    <h2 className="mb-3">Collect Kart Brochure</h2>
    <a className="btn btn-danger">Download Now</a>
  </div>
</section>

 

     </main>
  );
}
